import { render, staticRenderFns } from "./TableCellFioDocument.vue?vue&type=template&id=2f29b21c&"
import script from "./TableCellFioDocument.vue?vue&type=script&lang=ts&"
export * from "./TableCellFioDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports